import {Component} from '@angular/core';
import {Button} from 'primeng/button';
import {NavigatorDirective} from '../../../shared/directive/navigator.directive';
import {formComponentSignal} from '../../../shared/signal/common/form-component.signal';
import {isSpecialOfferSignal} from '../../../shared/signal/auctions/special-offer-component.signal';

@Component({
  selector: 'app-auctions-bait',
  imports: [
    Button,
    NavigatorDirective
  ],
  templateUrl: './auctions-bait.component.html',
  styleUrl: './auctions-bait.component.scss'
})
export class AuctionsBaitComponent {

  protected readonly auctionsFormComponentSignal = formComponentSignal;
  protected readonly isSpecialOfferSignal = isSpecialOfferSignal;
}
